import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from '@/hooks/use-app-selector';
import { clientInstance } from '@/query/client-instance';
import { INTERNAL_MEMBERS_ENDPOINT } from '@/query/internal-endpoints';
import { MEMBER_QUERY_KEY } from '@/query/query-keys';

export const useQueryMember = (currentMemberId?: string) => {
  const memberId = useAppSelector((state) => state.auth.user?.memberId) || currentMemberId;

  return useQuery<MarketingMember>({
    queryFn: async () => (await clientInstance.get(`${INTERNAL_MEMBERS_ENDPOINT}/${memberId}`)).data.data,
    queryKey: [MEMBER_QUERY_KEY, memberId],
    enabled: Boolean(memberId)
  });
};
